//@flow

import React from "react";
import { Container } from "reactstrap";

import style from "./style.module.scss";

type Props = {
    children: *,
    searchPage?: boolean,
};

const PropertyBanner = ({ children, searchPage }: Props) => (
    <Container
        fluid
        className={`${style.searchResultBanner} ${
            searchPage ? style.searchPage : ""
        }`}
    >
        {children}
    </Container>
);

export default PropertyBanner;
